<template>
  <div>
    <card-component>
      <section class="section is-title-bar">
        <div class="level-right">
          <div class="buttons">
            <router-link class="button is-link is-small btnicon" :to="{ name: 'admission' }" title="back">Back to list </router-link>
          </div>
        </div>
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="title is-5">Find Registered student details</p>
            </div>
          </div>
        </div>
        Total Records : <b>{{ total }}</b>
      </section>

      <section class="section is-main-section">
        <form class="" @submit.prevent="getRegistration">
          <div class="columns is-centered">
            <div class="column">
              <div class="field">
                <label class="label">Select Academic Year <span class="has-text-danger">*</span></label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="findEnquiry.academicYearID" required @change="onChangeAcademicyearID">
                      <option value="">-select</option>
                      <option v-for="year in academicYears" :key="year.id" :value="year.id"> {{ year.academicYear }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Search By <span class="has-text-danger">*</span></label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="findEnquiry.searchType" @change="updateSearchValue" required>
                      <option value="mobileNo">Mobile Number</option>
                      <option value="studentName">Student Name</option>
                      <option value="applicationNo">Application Number</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field column">
              <label class="label">Search value <span class="has-text-danger">*</span></label>
              <div class="control">
                <b-autocomplete
                  v-model="findEnquiry.searchKey"
                  onKeyPress="if(this.value.length==10) return false;"
                  v-if="findEnquiry.searchType === 'mobileNo'"
                  placeholder="Enter Mobile Number"
                  @input="studEnquiry()"
                  @keydown="option => (option ? getSearchValue(option) : '')"
                  @select="option => (option ? getSearchValue(option) : '')"
                  :data="findDataArr"
                >
                </b-autocomplete>
                <b-autocomplete
                  v-model="findEnquiry.searchKey"
                  v-if="findEnquiry.searchType === 'studentName'"
                  placeholder="Enter student name"
                  @input="studEnquiry()"
                  @keydown="option => (option ? getSearchValue(option) : '')"
                  @select="option => (option ? getSearchValue(option) : '')"
                  :data="findDataArr"
                >
                </b-autocomplete>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Action</label>
                <button class="button is-success" type="submit" readonly>Search</button>
                &nbsp;
              </div>
            </div>
          </div>
        </form>
      </section>
      <section class="section is-main-section">
        <card-component title="" class="has-table">
          <b-table :paginated="true" :per-page="10" :striped="true" :hoverable="true" :data="enquiryData">
            <template slot-scope="props">
              <b-table-column label="Student Name" field="Student Name" sortable>
                {{ props.row.studentFirstName }}
              </b-table-column>

              <b-table-column label="Parent Name" field="Father Name">
                {{ props.row.fatherName }}
              </b-table-column>

              <b-table-column label="Parent Mobile" field="Father Mobile" sortable>
                {{ props.row.fatherMobile }}
              </b-table-column>
              <b-table-column label="Parent Email" field="Father Email" sortable>
                {{ props.row.fatherEmailID }}
              </b-table-column>

              <b-table-column label="Application Code" field="Application Code" sortable>
                {{ props.row.applicationCode }}
              </b-table-column>
              <b-table-column label="Action" field="Action" sortable>
                <div class="buttons">
 <router-link
                    class="button is-danger is-small btnicon"
                    :to="{ name: 'admissionForm', params: { enquiryID: props.row.id, enquiryCode: props.row.enquiryCode } }"
                    title="create Admission"
                  >
                    Create Admission
                  </router-link>

                </div>
              </b-table-column>
            </template>

            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                  <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                  </p>
                  <p>Fetching data...</p>
                </template>
                <template v-else>
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large" />
                  </p>
                  <p>Nothing's here&hellip;</p>
                </template>
              </div>
            </section>
          </b-table>
        </card-component>
      </section>
    </card-component>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'FindAdmission',
  props: ['radio2'],
  components: {
    CardComponent
  },
  data () {
    return {
      isWrite: false,
      searchTerm: '',
      radio: 'all',
      total: 0,
      isLoading: false,
      loadingComponent: null,
      enquiryData: [],
      findData: [],
      findDataArr: [],
      searchKey: '',
      franchiseeID: '',
      findEnquiry: {
        academicYearID: '',
        searchType: 'mobileNo',
        searchKey: ''
      },
      filter: {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      }
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    try {
      this.loadingComponent = this.$buefy.loading.open()
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.filter.academicYearID = this.findEnquiry.academicYearID = academicYear ? academicYear.id : ''
      this.loadingComponent.close()
      this.onFranchiseeChange()
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    getSearchValue: async function (objKey) {
      this.enquiryData = []
      this.findEnquiry.searchKey = objKey
      this.getRegistration()
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.enquiryData = []
        this.studEnquiry()
        this.getRegistration()

        this.inProgress = false
      }
    },
    studEnquiry: async function () {
      try {
        if (
          (this.findEnquiry.searchType === 'studentName' && this.findEnquiry.searchKey.length < 3) ||
          (this.findEnquiry.searchType === 'mobileNo' && this.findEnquiry.searchKey.length < 3) ||
          (this.findEnquiry.searchType === 'applicationNo' && this.findEnquiry.searchKey.length < 3)
        ) {
          return
        }
        if ((this.franchiseeID) && (this.academicYear)) {
          const { data } = await http.post(`${constants.API_URL}/api/search-registrationdata`, {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYear.id,
            searchType: this.findEnquiry.searchType,
            searchKey: this.findEnquiry.searchKey
          })
          this.findData = data
          let nameArray = ''
          if (this.findEnquiry.searchType === 'mobileNo') {
            nameArray = this.findData.map(i => i.fatherMobile)
          } else if (this.findEnquiry.searchType === 'applicationNo') {
            nameArray = this.findData.map(j => j.applicationCode)
          } else {
            nameArray = this.findData.map(k => k.studentFirstName)
          }

          this.findDataArr = await this.FilterResultData(nameArray)
          console.log('this.findDataArr', this.findDataArr)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    passed: function () {
      if (this.findEnquiry.searchKey === '' && this.findEnquiry.searchType === 'mobileNo') {
        this.$buefy.toast.open({
          message: 'Enter Mobile Number',
          queue: false,
          type: 'is-danger'
        })
      } else if (this.findEnquiry.searchKey === '' && this.findEnquiry.searchType === 'studentName') {
        this.$buefy.toast.open({
          message: 'Enter Student Name',
          queue: false,
          type: 'is-danger'
        })
      } else if (
        (this.findEnquiry.searchType === 'studentName' && this.findEnquiry.searchKey.length < 3) ||
        (this.findEnquiry.searchType === 'mobileNo' && this.findEnquiry.searchKey.length < 10)) {
        this.alertFunction()
      }
    },
    alertFunction: function () {
      if (this.findEnquiry.searchType === 'mobileNo') {
        this.$buefy.toast.open({
          message: 'enter 10 digit Mobile Number',
          queue: false,
          type: 'is-danger'
        })
      } else if (this.findEnquiry.searchType === 'studentName') {
        this.$buefy.toast.open({
          message: 'enter Student Name',
          queue: false,
          type: 'is-danger'
        })
      }
    },
    onChangeAcademicyearID: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        this.getRegistration()
        this.inProgress = false
      }
    },
    FilterResultData: async function (resObj) {
      return resObj.filter(option => {
        return option.indexOf(this.searchKey) >= 0
      })
    },
    getRegistration: async function () {
      try {
        if (_.isEmpty(this.findEnquiry.searchKey)) {
          return
        } else {
          if ((this.franchiseeID) && (this.academicYear)) {
            const response = await http.post(`${constants.API_URL}/api/search-registrationdata`, {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              searchType: this.findEnquiry.searchType,
              searchKey: this.findEnquiry.searchKey
            })

            if (response.data.length === 0) {
              this.$buefy.dialog.alert({
                title: 'Error',
                message:
                'Searched data is not found. This could be, because: <br> -Enquiry details not filled <br> -Application fee not paid <br> -Registration details not filled <br>Please check previous stages for completion',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            } else {
              this.enquiryData = response.data
              this.total = this.enquiryData.length
            }
            this.searchTerm = null
            this.loadingComponent.close()
          }
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: 'mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    updateSearchValue: function () {
      this.findEnquiry.searchKey = ''
    }
  }
}
</script>
